import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const faqs = [
    { question: t('faq.q1'), answer: t('faq.a1') },
    { question: t('faq.q2'), answer: t('faq.a2') },
    { question: t('faq.q3'), answer: t('faq.a3') },
    { question: t('faq.q4'), answer: t('faq.a4') }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-neutral-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-600 text-sm font-semibold uppercase tracking-wider">{t('faq.badge')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mt-4">{t('faq.title')}</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index}
              className={`bg-white rounded-2xl overflow-hidden shadow-sm transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}>
              <button
                className="w-full p-6 flex items-center justify-between text-left hover:bg-neutral-50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}>
                <span className="text-lg font-semibold text-neutral-900 pr-4">{faq.question}</span>
                <ChevronDown className={`flex-shrink-0 text-red-600 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48' : 'max-h-0'}`}>
                <p className="px-6 pb-6 text-neutral-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
